import React, { useEffect, useState } from 'react';
import { getTicketDetailAPI } from '@/service/ticketService';
import { API } from 'aws-amplify';
import Utils from '@/common/utils/utils';
import { Checkbox, FormControlLabel, Tooltip } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

export default function RenderTagItemMultiChoice({ item, indeterminate, name, id, status, handleOnChange, isTagMaster }) {
    const [itemLabel , setItemLabel] = useState(name);
    const [loading , setLoading] = useState(false);
    
    useEffect(() => {
        if (!isTagMaster) return;
        if(!itemLabel) {
            setLoading(true);
            getTicketDetailAPI(API, id).then((ticketDetailResult) => {
                let detailTicket = ticketDetailResult.detailTicket;
                let titketTitle =  Utils.getTitle(detailTicket?.settingTitle);
                setLoading(false);
                setItemLabel(titketTitle);
            })
        }
    }, [item]);

    if (loading) {
        return (
            <FormControlLabel
                control={
                    <Checkbox
                        className="hello"
                        checked={status === 'checked'}
                        indeterminate={indeterminate}
                        onChange={e => handleOnChange(item)}
                    />
                }
                label={<Skeleton variant="text" width={200} height={30} />}
                className={`checkbox-item-of-tag-field label-item-name`}
                id={id}
                key={`${id}-tag-item-loading`}
            />
        )
    }

    return (
        <Tooltip title={`${itemLabel}`} arrow= {false} placement = "top-center">
            <p>
            <FormControlLabel
                control={
                    <Checkbox
                        className="hello"
                        checked={status === 'checked'}
                        indeterminate={indeterminate}
                        onChange={e => handleOnChange(item)}
                    />
                }
                label={`${itemLabel}`}
                className={`checkbox-item-of-tag-field label-item-name`}
                id={id}
                key={`${id}-tag-item`}
            />
            </p>
        </Tooltip>
    );
}